import { createApp, Fragment, h } from 'vue';
import App from './App.vue';
import router from './router/';
import i18n from './i18n';
import { createPinia } from 'pinia';
import loadingDirectives from './directives';
import SvgIcon from '@/components/SvgIcon.vue';
import Notifications from '@kyvg/vue3-notification';
import FloatingVue from 'floating-vue';
import vueAxeConfig from './plugins/vueAxe.js';
import './assets/css/main.css';
// Required for VDropdown/VMenu/VTooltip positioning: without it, the popper
// content has `position: absolute` (set inline by floating-ui) but no base
// top/left anchor, so it renders at its static in-flow position instead of
// floating next to its trigger.
import 'floating-vue/dist/style.css';

const setupApp = async (app) => {
  app.config.productionTip = false;

  app.use(createPinia());
  app.use(i18n);

  // Plugins
  app.use(Notifications);
  app.use(FloatingVue);

  // Directives
  app.directive('loading', loadingDirectives);

  // Global Components
  app.component('SvgIcon', SvgIcon);

  // Silently restore session before installing the router so the beforeEach
  // guard sees the correct auth state on initial navigation.
  const { useAuthStore } = await import('./store/Auth.js');
  try {
    await useAuthStore().fetchLoggedUser();
  } catch {
    // not logged in, that's fine
  }

  app.use(router);
  app.mount('#app');
};

// Initiate app with VueAxe if in development mode
if (process.env.NODE_ENV === 'development') {
  import('vue-axe').then((res) => {
    const VueAxe = res.default;
    const VueAxePopup = res.VueAxePopup;
    const app = createApp({
      render: () => h(Fragment, [h(App), h(VueAxePopup)]),
    });
    app.use(VueAxe, vueAxeConfig);
    setupApp(app);
  });
} else {
  const app = createApp(App);
  setupApp(app);
}
